module.exports = __webpack_public_path__ + "img/CHF.5125cd53.svg";